'use client';

import { forwardRef } from 'react';
import MuiRadioGroup, { type RadioGroupProps as MuiRadioGroupProps } from '@mui/material/RadioGroup';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import FormHelperText from '@mui/material/FormHelperText';

export interface RadioGroupProps extends MuiRadioGroupProps {
  label?: string;
  helperText?: string;
  error?: boolean;
}

export const RadioGroup = forwardRef<HTMLDivElement, RadioGroupProps>(
  ({ label, helperText, error, children, ...props }, ref) => {
    return (
      <FormControl ref={ref} error={error}>
        {label && <FormLabel>{label}</FormLabel>}
        <MuiRadioGroup {...props}>{children}</MuiRadioGroup>
        {helperText && <FormHelperText>{helperText}</FormHelperText>}
      </FormControl>
    );
  }
);

RadioGroup.displayName = 'RadioGroup';
